import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AdminMeResponseDto } from '@api/sweetnya/model';

// 인증된 관리자 정보 (GET /api/v1/admin/auth/me 응답 형태)
export type AuthAdmin = AdminMeResponseDto;

type AuthState = {
	// State
	admin: AuthAdmin | null; // 관리자 정보
	accessToken: string | null;
	isAuthenticated: boolean; // 인증 여부
	isLoading: boolean; // 로딩 상태
	// Action
	setAdmin: (admin: AuthAdmin | null) => void;
	setAccessToken: (token: string | null) => void;
	setIsAuthenticated: (isAuthenticated: boolean) => void;
	setIsLoading: (isLoading: boolean) => void;
	login: (admin: AuthAdmin, accessToken: string) => void;
	logout: () => void;
	reset: () => void;
}

// 초기 상태 - 비인증 상태로 시작 (실서버 인증 연동). 세션 복원 전까지 로딩.
const initialState = {
	admin: null as AuthAdmin | null,
	accessToken: null as string | null,
	isAuthenticated: false,
	isLoading: true,
};

export const useAuthStore = create<AuthState>()(
	persist(
		(set) => ({
			...initialState,
			// setter 함수
			setAdmin: (admin) => set({ admin }),
			setAccessToken: (accessToken) => set({ accessToken }),
			setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
			setIsLoading: (isLoading) => set({ isLoading }),
			// 로그인
			login: (admin, accessToken) => set({
				admin,
				accessToken,
				isAuthenticated: true,
				isLoading: false,
			}),
			// 로그아웃 (mock 상태로 복귀가 아닌 비인증 상태로)
			logout: () => set({
				admin: null,
				accessToken: null,
				isAuthenticated: false,
				isLoading: false,
			}),
			// 전체 초기화
			reset: () => set(initialState),
		}),
		{
			name: 'auth-storage',
			storage: createJSONStorage(() => localStorage),
			partialize: (state) => ({
				// 보안을 위해 오직 인증 여부만 localStorage에 저장
				isAuthenticated: state.isAuthenticated,
			}),
		},
	),
);
